import React from 'react';
import { Link } from 'react-router-dom';
import TablePagination from '../components/TablePagination';
import { useTablePagination } from '../hooks/useTablePagination';
import MetricHeader from '../components/MetricHeader';

type QualityStatus = '好' | '一般' | '—';
type NullableNumber = number | null;

interface MeetingQuality {
  status: QualityStatus;
  score?: number;
}

interface MeetingRecord {
  id: string;
  topic: string;
  creator: string;
  account: string;
  overall: MeetingQuality;
  audio: MeetingQuality;
  video: MeetingQuality;
  screen: MeetingQuality;
  network: MeetingQuality;
  loginSuccessRate: NullableNumber;
  audioStutterRate: NullableNumber;
  audioStutterCount: NullableNumber;
  videoStutterRate: NullableNumber;
  videoStutterCount: NullableNumber;
  screenStutterRate: NullableNumber;
  screenStutterCount: NullableNumber;
  avgLatencyMs: NullableNumber;
  reconnectCount: NullableNumber;
  startTime: string;
  participants: number;
  videoEnabled: boolean;
  screenEnabled: boolean;
  recordEnabled: boolean;
}

export const realTimeMeetingRecords: MeetingRecord[] = [
  {
    id: '863415',
    topic: '重要监管指令沟通',
    creator: '梁小雨',
    account: 'liangxiaoyu',
    overall: { status: '—' },
    audio: { status: '—' },
    video: { status: '—' },
    screen: { status: '—' },
    network: { status: '—' },
    loginSuccessRate: null,
    audioStutterRate: null,
    audioStutterCount: null,
    videoStutterRate: null,
    videoStutterCount: null,
    screenStutterRate: null,
    screenStutterCount: null,
    avgLatencyMs: null,
    reconnectCount: null,
    startTime: '2026-02-12 10:15:00',
    participants: 2,
    videoEnabled: false,
    screenEnabled: false,
    recordEnabled: false
  },
  {
    id: '111511',
    topic: '王海预定的会议',
    creator: '王海',
    account: 'wanghai3',
    overall: { status: '好', score: 95.94 },
    audio: { status: '好', score: 99 },
    video: { status: '—' },
    screen: { status: '—' },
    network: { status: '好', score: 92.87 },
    loginSuccessRate: 99.86,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 560,
    reconnectCount: 1.2,
    startTime: '2026-02-11 16:03:44',
    participants: 2,
    videoEnabled: false,
    screenEnabled: false,
    recordEnabled: false
  },
  {
    id: '940105',
    topic: '韩济旭的快速会议',
    creator: '韩济旭',
    account: 'hanjixu',
    overall: { status: '好', score: 98.01 },
    audio: { status: '好', score: 100 },
    video: { status: '—' },
    screen: { status: '好', score: 100 },
    network: { status: '好', score: 94.03 },
    loginSuccessRate: 98.32,
    audioStutterRate: 0.32,
    audioStutterCount: 1,
    videoStutterRate: 0.28,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 520,
    reconnectCount: 0.8,
    startTime: '2026-02-11 16:02:55',
    participants: 2,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '344657',
    topic: '武雅芳的快速会议',
    creator: '武雅芳',
    account: 'wuyafang',
    overall: { status: '好', score: 94.61 },
    audio: { status: '好', score: 100 },
    video: { status: '—' },
    screen: { status: '—' },
    network: { status: '一般', score: 89.22 },
    loginSuccessRate: 97.11,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 610,
    reconnectCount: 1.5,
    startTime: '2026-02-11 15:58:26',
    participants: 2,
    videoEnabled: false,
    screenEnabled: false,
    recordEnabled: false
  },
  {
    id: '945579',
    topic: '张晋通预定的会议',
    creator: '张晋通',
    account: 'zhangjintong',
    overall: { status: '好', score: 97.93 },
    audio: { status: '好', score: 99 },
    video: { status: '—' },
    screen: { status: '好', score: 99 },
    network: { status: '好', score: 95.8 },
    loginSuccessRate: 98.62,
    audioStutterRate: 0.28,
    audioStutterCount: 1,
    videoStutterRate: 0.3,
    videoStutterCount: 1,
    screenStutterRate: 0.22,
    screenStutterCount: 1,
    avgLatencyMs: 430,
    reconnectCount: 0.6,
    startTime: '2026-02-11 15:54:18',
    participants: 6,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '447513',
    topic: '刘晔敏的快速会议',
    creator: '刘晔敏',
    account: 'liuyemin',
    overall: { status: '好', score: 98.43 },
    audio: { status: '好', score: 100 },
    video: { status: '—' },
    screen: { status: '好', score: 100 },
    network: { status: '好', score: 95.28 },
    loginSuccessRate: 99.21,
    audioStutterRate: 0.18,
    audioStutterCount: 1,
    videoStutterRate: 0.22,
    videoStutterCount: 1,
    screenStutterRate: 0.2,
    screenStutterCount: 1,
    avgLatencyMs: 410,
    reconnectCount: 0.4,
    startTime: '2026-02-11 15:05:47',
    participants: 2,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '909311',
    topic: '彭科预定的会议',
    creator: '彭科',
    account: 'pengke1',
    overall: { status: '好', score: 98.79 },
    audio: { status: '好', score: 99 },
    video: { status: '—' },
    screen: { status: '好', score: 98 },
    network: { status: '好', score: 99.38 },
    loginSuccessRate: 99.32,
    audioStutterRate: 0.16,
    audioStutterCount: 1,
    videoStutterRate: 0.18,
    videoStutterCount: 1,
    screenStutterRate: 0.2,
    screenStutterCount: 1,
    avgLatencyMs: 390,
    reconnectCount: 0.2,
    startTime: '2026-02-11 15:03:03',
    participants: 14,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '301973',
    topic: '举报研判会',
    creator: '沈宣毅',
    account: 'shenxueyi',
    overall: { status: '好', score: 99.71 },
    audio: { status: '好', score: 100 },
    video: { status: '—' },
    screen: { status: '好', score: 100 },
    network: { status: '好', score: 99.13 },
    loginSuccessRate: 99.6,
    audioStutterRate: 0.12,
    audioStutterCount: 1,
    videoStutterRate: 0.14,
    videoStutterCount: 1,
    screenStutterRate: 0.1,
    screenStutterCount: 1,
    avgLatencyMs: 360,
    reconnectCount: 0.1,
    startTime: '2026-02-10 14:31:25',
    participants: 12,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '118193',
    topic: '高翠莲预定的会议',
    creator: '高翠莲',
    account: '18636162313',
    overall: { status: '—' },
    audio: { status: '—' },
    video: { status: '—' },
    screen: { status: '—' },
    network: { status: '—' },
    loginSuccessRate: null,
    audioStutterRate: null,
    audioStutterCount: null,
    videoStutterRate: null,
    videoStutterCount: null,
    screenStutterRate: null,
    screenStutterCount: null,
    avgLatencyMs: null,
    reconnectCount: null,
    startTime: '2025-11-28 11:07:17',
    participants: 1,
    videoEnabled: false,
    screenEnabled: false,
    recordEnabled: false
  },
  {
    id: '207492',
    topic: '推推技术支持2预定的会议',
    creator: '推推技术支持2',
    account: 'im-test01',
    overall: { status: '—' },
    audio: { status: '—' },
    video: { status: '—' },
    screen: { status: '—' },
    network: { status: '—' },
    loginSuccessRate: null,
    audioStutterRate: null,
    audioStutterCount: null,
    videoStutterRate: null,
    videoStutterCount: null,
    screenStutterRate: null,
    screenStutterCount: null,
    avgLatencyMs: null,
    reconnectCount: null,
    startTime: '2025-11-28 11:06:55',
    participants: 1,
    videoEnabled: false,
    screenEnabled: false,
    recordEnabled: false
  }
];

const RealTimeMeetings: React.FC = () => {
  const loginSuccessDesc = '5s内加入会议成功人次/尝试加入会议人次';
  const audioStutterDesc = '音频卡顿超过200ms的时长 / 按流计算的总视频时长 × 100%（会议内卡顿总次数）';
  const videoStutterDesc = '视频卡顿超过500ms的时长 / 按流计算的总视频时长 × 100%（会议内卡顿总次数）';
  const screenStutterDesc = '屏幕共享卡顿超过1000ms的时长 / 按流计算的总视频时长 × 100%（会议内卡顿总次数）';

  const meetings = realTimeMeetingRecords;
  const {
    total,
    page,
    pageCount,
    pageSize,
    pagedRows,
    setPage,
    setPageSize
  } = useTablePagination(meetings);

  const renderQuality = (quality: MeetingQuality) => {
    if (quality.status === '—') {
      return <span className="quality-empty">—</span>;
    }
    const colorClass = quality.status === '好' ? 'good' : 'normal';
    return (
      <span className={`quality-chip ${colorClass}`}>
        <span className="quality-dot" />
        {quality.status} ({quality.score})
      </span>
    );
  };

  const renderFlag = (enabled: boolean) => (
    <span className={`flag-chip ${enabled ? 'enabled' : 'disabled'}`}>
      {enabled ? '已启用' : '未启用'}
    </span>
  );

  const formatPercent = (value: NullableNumber) => {
    if (value === null) {
      return '—';
    }
    return Number.isInteger(value) ? `${value}%` : `${value.toFixed(2)}%`;
  };

  const formatCount = (value: NullableNumber) => {
    if (value === null) {
      return '—';
    }
    return Number.isInteger(value) ? `${value}` : value.toFixed(1);
  };

  const renderRateWithCount = (rate: NullableNumber, count: NullableNumber) => {
    if (rate === null || count === null) {
      return <span className="quality-empty">—</span>;
    }
    return (
      <span className="metric-cell">
        {`${rate.toFixed(2)}% (${formatCount(count)}次)`}
      </span>
    );
  };

  const renderLatency = (value: NullableNumber) => (
    value === null ? <span className="quality-empty">—</span> : `${value}ms`
  );

  return (
    <div className="page-block">
      <div className="breadcrumb">
        <span>会议</span>
        <span className="breadcrumb-sep" aria-hidden="true">›</span>
        <Link to="/real-time" className="breadcrumb-link">实时会议</Link>
      </div>
      <div className="page-card">
        <div className="toolbar">
          <div className="toolbar-left">
            <select className="toolbar-select">
              <option>会议ID</option>
              <option>主题</option>
              <option>创建者</option>
            </select>
            <input className="toolbar-input" placeholder="请输入" />
            <button type="button" className="toolbar-icon" aria-label="搜索">
              <span className="icon icon-search" />
            </button>
            <button type="button" className="toolbar-icon" aria-label="刷新">
              <span className="icon icon-refresh" />
            </button>
          </div>
          <button type="button" className="toolbar-export">
            <span className="icon icon-download" />
          </button>
        </div>

        <div className="table-container">
          <table className="compact-table">
            <thead>
              <tr>
                <th>会议ID</th>
                <th>主题</th>
                <th>创建者</th>
                <th>账号</th>
                <th>整体质量</th>
                <th>音频质量</th>
                <th>视频质量</th>
                <th>共享屏幕质量</th>
                <th>网络质量</th>
                <th><MetricHeader label="5s登录成功率" description={loginSuccessDesc} /></th>
                <th><MetricHeader label="音频卡顿率（次数）" description={audioStutterDesc} /></th>
                <th><MetricHeader label="视频卡顿率（次数）" description={videoStutterDesc} /></th>
                <th><MetricHeader label="屏幕共享卡顿率（次数）" description={screenStutterDesc} /></th>
                <th>平均延迟</th>
                <th>重连次数</th>
                <th>开始时间</th>
                <th>参与者</th>
                <th>视频</th>
                <th>屏幕共享</th>
                <th>录制</th>
              </tr>
            </thead>
            <tbody>
              {pagedRows.map(item => (
                <tr key={item.id}>
                  <td>
                    <Link to={`/real-time/${item.id}`} className="link-text meeting-id-link">
                      {item.id}
                    </Link>
                  </td>
                  <td>{item.topic}</td>
                  <td>{item.creator}</td>
                  <td>{item.account}</td>
                  <td className="nowrap-cell">{renderQuality(item.overall)}</td>
                  <td className="nowrap-cell">{renderQuality(item.audio)}</td>
                  <td className="nowrap-cell">{renderQuality(item.video)}</td>
                  <td className="nowrap-cell">{renderQuality(item.screen)}</td>
                  <td className="nowrap-cell">{renderQuality(item.network)}</td>
                  <td className="metric-cell nowrap-cell">{formatPercent(item.loginSuccessRate)}</td>
                  <td className="nowrap-cell">{renderRateWithCount(item.audioStutterRate, item.audioStutterCount)}</td>
                  <td className="nowrap-cell">{renderRateWithCount(item.videoStutterRate, item.videoStutterCount)}</td>
                  <td className="nowrap-cell">{renderRateWithCount(item.screenStutterRate, item.screenStutterCount)}</td>
                  <td className="metric-cell nowrap-cell">{renderLatency(item.avgLatencyMs)}</td>
                  <td className="metric-cell nowrap-cell">{formatCount(item.reconnectCount)}</td>
                  <td>{item.startTime}</td>
                  <td>{item.participants}</td>
                  <td className="nowrap-cell">{renderFlag(item.videoEnabled)}</td>
                  <td className="nowrap-cell">{renderFlag(item.screenEnabled)}</td>
                  <td className="nowrap-cell">{renderFlag(item.recordEnabled)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <TablePagination
          total={total}
          page={page}
          pageCount={pageCount}
          pageSize={pageSize}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
        />
      </div>
    </div>
  );
};

export default RealTimeMeetings;
